<template>

  <div>
      
        <app-layout title="Aruvaa" >
          <template v-slot:adminnav >
          </template> 
         
      
          <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
            <div class="mt-3 mb-2">
              <jet-back-link   @click="back" class="">
                  <i class="fa fa-long-arrow-left" aria-hidden="true"></i>
                     &nbsp;
                     Go back
              </jet-back-link>
          </div>    
             <p class="font-semibold text-lg text-gray-800 leading-tight"> Roles </p>
          <p class=" text-xs">We’re updating the cards and ranking all the time, so check back regularly.</p>
          <!-- <jet-button @click="back"  class="bg-blue-500 rounded text-white hover:bg-blue-500  hover:no-underline px-2  cursor-pointer  text-sm" >Back</jet-button> -->
          <!-- buttons start -->
         
          <!-- buttons end -->
          </div>
          <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 mt-2">
            <div class="w-full">
              <form @submit.prevent="submit">
              <div class="flex justify-start ...">
                  <jet-button
                    v-show="!checkAction()"
                    type="submit"
                    class="
                      bg-green-500
                      rounded
                      text-white
                      hover:bg-green-700 hover:no-underline
                      px-2
                      cursor-pointer
                      text-sm
                    "
                    >Save</jet-button
                  >
                  <jet-button
                    @click="CreateAnother"
                    class="
                      bg-blue-500
                      rounded
                      text-white
                      hover:bg-blue-700 hover:no-underline
                      px-2
                      cursor-pointer
                      text-sm
                    "
                    >Save & Create Another</jet-button
                  >
                  <jet-button
                    @click.prevent="back"
                    @click="back"
                    class="
                      bg-gray-500
                      rounded
                      text-white
                      hover:text-white
                      hover:bg-gray-700 hover:no-underline
                      px-2
                      cursor-pointer
                      text-sm
                    "
                    >Cancel</jet-button
                  >
              </div>
              <div class="bg-white shadow-md rounded px-8 pt-6 pb-8 my-2">
               
                  <BsRoleEdit  :createDef="createDef" 
                   :routeDef="moduleRoute" 
                   :modelData="modelData" 
                    ref="formRoleRenderer">
                  </BsRoleEdit>
                  <div class="panel-footer mt-2">
                
                    <!-- <jet-button
                      v-show="!checkAction()"
                      type="submit"
                      class="
                        bg-green-500
                        text-sm
                        rounded
                        pl-2
                        pr-2
                        pt-1
                        hover:bg-green-500
                        text-white
                        hover:no-underline
                      "
                    >
                      Submit
                    </jet-button> -->

                  </div>
                
              </div>
              
              <!-- buttons start -->
              <div class="flex justify-start ...">
                      <jet-button
                        v-show="!checkAction()" 
                        type="submit"
                        class="
                          bg-green-500
                          rounded
                          text-white
                          hover:bg-green-700 hover:no-underline
                          px-2
                          cursor-pointer
                          text-sm
                        "
                        >Save</jet-button
                      >
                      <jet-button
                        @click="CreateAnother"
                        class="
                          bg-blue-500
                          rounded
                          text-white
                          hover:bg-blue-700 hover:no-underline
                          px-2
                          cursor-pointer
                          text-sm
                        "
                        >Save & Create Another</jet-button
                      >
                      <jet-button
                        @click.prevent="back"
                        @click="back"
                        class="
                          bg-gray-500
                          rounded
                          text-white
                          hover:text-white
                          hover:bg-gray-700 hover:no-underline
                          px-2
                          cursor-pointer
                          text-sm
                        "
                        >Cancel</jet-button
                      >
                </div>
              <!-- buttons end -->
  
            </form>
          
          
          <DxToast
            v-model:visible="isVisible"
            v-model:message="message"
            v-model:type="type"
          />
  
  
            </div>
           
          </div>
        </app-layout>
  </div>
  </template>
  
  
  <script>
  import AppLayout from "@/Layouts/AppLayout.vue";
  import BsRoleEdit from "@/Base/BsTAdminRoleEdit.vue";
  import PageTitle from "@/Layouts/PageTitle.vue";
  import JetNavLink from "@/Jetstream/NavLink.vue";
  import JetButton from "@/Jetstream/Button.vue";
  import { DxToast } from 'devextreme-vue/toast';
  import MobileNavigation from "@/Layouts/MobileNavigation.vue";
  import MobileNavigationBack from "@/Layouts/MobileNavigationBack.vue";
  import JetBackLink from "@/Jetstream/BackLink.vue";
  
  const modelData = {};
  
  export default {
    props: {
      createDef: Array,
      moduleRoute: String,
      moduleName: String,
      slug:String,
      modelData: {
        type: Object,
        default: () => ({}),
      },
    },
    components: {
      AppLayout,
      BsRoleEdit,
      PageTitle,
      JetNavLink,
      JetButton,
      DxToast,
      MobileNavigation,
      MobileNavigationBack,
      JetBackLink,
  
    },
    data: function () {
      return {
       // title: this.moduleRoute + " Create",
        form: this.$inertia.form(),
        isVisible: false,
        message: '',
        type: 'success',
      };
    },
    methods: {
       showToast(message,type)
          {
            this.isVisible = true;
            this.message = message;
            this.type = type;
          },
      checkAction() {
        return this.modelData.hasOwnProperty("id") && this.modelData.id != "";
      },
      submit() {
  
        console.log("Tenant Role Form",this.$refs.formRoleRenderer.formData);
        this.$refs.formRoleRenderer.formData.route_slug = this.slug
        this.form.post(
           route("tenant-admin-panels.roles.store", this.$refs.formRoleRenderer.formData),
           {
             onComplete: this.showToast("Successfully completed", "success"),     
           }
        );
   
      },
  
      back() {
              this.$inertia.get('/'+this.slug+'/'+this.moduleRoute);
      },
      
  
      update() {
        
          this.form.post(
                  route(this.moduleRoute + ".update", this.$refs.formRenderer.formData),
                  {
                    onSuccess: this.showToast("Successfully ", "success"),
  
                  }
                );
      }
    },
    mounted() {
      
    },
  };
  </script>
  
  
  
  <style>
  
  .grey-background-container{
    background-color:#ffffff;
    height:100vh;
  }
  
  </style>